import React from 'react';

export const TsuMagAbeModal = {
  title: 'Tsunami Magnitude (Abe)',
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>-5 to 10</b>
      </div>
      <br />
      <p>Abe defined two different tsunami magnitude amplitudes. His first tsunami magnitude (1979) is:</p>
      <p>Mt = logH + B</p>
      <p>where H is the maximum single crest or trough amplitude of the tsunami waves (in meters) and B a constant. The second definition (1981) is:</p>
      <p>Mt = logH + alogR + D</p>
      <p>where R is the distance in km from the earthquake epicenter to the tide station along the shortest oceanic path, and a and D are constants.</p>
    </div>
  ),
};
